import React from "react"
import { Row, Col, Container } from "react-bootstrap"
import { StaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "styled-components"
import { Link } from "gatsby"

class Vasco extends React.Component {
  shouldComponentUpdate() {
    return false
  }

  constructor(props) {
    super(props)
    this.state = {
      height: 0,
      width: 0,
    }
  }

  updateDimensions = () => {
    if (this.state.height !== window.innerHeight) {
      this.setState({ height: window.innerHeight })
    }
    if (this.state.width !== window.innerWidth) {
      this.setState({ width: window.innerWidth })
    }
  }

  componentDidMount() {
    this.setState({ height: window.innerHeight, width: window.innerWidth })
    window.addEventListener("resize", this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  render() {
    const generateEmailAddress = () => {
      const username = "ventas"
      const domain = "vascosolutions.com"
      return `${username}@${domain}`
    }

    const Section = styled.section`
      position: relative;
      overflow: hidden;
      background-color: #1a1a1a;

      background-size: cover;
      background-repeat: no-repeat;
      background-size: 500px;
      background-position: center;
      padding: 100px 0 50px 0;
      .heading {
        width: 100%;
      }
      @media (max-width: 767px) {
        padding: 50px 0 50px 0;
      }
      @media (min-width: 768px) and (max-width: 1500px) {
        padding: 50px 0 50px 0;
      }
    `

    const ServiceRow = styled(Row)`
      margin-top: 100px;
    `

    const ServiceRowF = styled(Row)`
      margin-top: 20px;
    `

    const ServiceHeading2 = styled.h2`
      font-size: 28px;
      font-weight: 500;
      font-family: Poppins;
      color: #c1eb18;
      margin-bottom: 5px;
    `

    const ServiceHeading2i = styled.h2`
      font-size: 28px;
      font-weight: 500;
      font-family: Poppins;
      color: #c1eb18;
      margin: 55px 0 5px 0;
    `

    const ServiceHeading3 = styled.h3`
      font-size: 18px;
      font-family: Poppins;
      color: #c1eb18;
      margin-bottom: 20px;
      font-weight: normal;
      @media (max-width: 767px) {
        font-size: 20px;
      }
    `

    const ServiceHeading3v = styled.h3`
      font-size: 18px;
      font-family: Poppins;
      color: #ffffff;
      margin-bottom: 30px;
      font-weight: normal;
      text-align: center;
    `

    const ServiceHeadinga = styled(Link)`
      color: #fff;
      transition: 0.5s;
      &:hover {
        color: #c1eb18;
        text-decoration: none;
      }
    `

    const ServiceSeparator = styled.div`
      height: 2px;
      width: 50px;
      background-color: #84a841;
      margin-bottom: 15px;
    `

    const ServiceLinea = styled.div`
      height: 1px;
      width: 200px;
      background-color: #808080;
      margin: 2px 0 7px 0;
    `

    const ServiceNumber = styled.p`
      position: absolute;
      font-size: 30px;
      color: #717171;
      font-weight: 900;
      top: -50px;
      opacity: 0.1;
      z-index: -1;
      transition: 0.2s;
    `

    const ServiceElement = styled.div`
      margin-bottom: 90px;
      border-radius: 20px;
      transition: 0.2s;
      position: relative;
      &:hover ${ServiceNumber} {
        opacity: 0.3 !important;
        color: #ff6d37;
      }
    `

    const ServiceText = styled.p`
      font-size: 16px;
      font-weight: 300;
      color: #cccccc;
      padding-right: 25px;
    `
    const ServiceImg = styled.div`
      display: flex;
      justify-content: center; /* Centra horizontalmente */
      padding-bottom: 30px;
    `

    const Text = styled.p`
      font-size: 18px;
      font-weight: 300;
      color: #fff;
    `

    const { data } = this.props
    const imageData = getImage(data.background.childImageSharp.gatsbyImageData)

    return (
      <Section>
        <GatsbyImage
          image={imageData}
          alt="VASCO Solutions"
          style={{
            position: "absolute",
            width: "500px",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
        <Container>
          <ServiceRow>
            <Col md={3}>
              <ServiceElement>
                <ServiceHeading2>IaaS</ServiceHeading2>
                <ServiceSeparator />
                <ServiceHeading3>
                  <ServiceHeadinga to="/correo-corporativo">
                    Correo Corporativo
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/google-workspace">
                    Google Workspace
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/seo">SEO</ServiceHeadinga>
                </ServiceHeading3>

                <ServiceHeading2i>Empresa</ServiceHeading2i>
                <ServiceSeparator />
                <ServiceHeading3>
                  <ServiceHeadinga to="/vasco-solutions">
                    Nuestra empresa
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/aviso-legal">
                    Aviso legal
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/aviso-privacidad">
                    Aviso de Privacidad
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/politicas-de-privacidad">
                    Política de privacidad
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/politica-de-cookies">
                    Política de cookies
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/terminos-y-condiciones">
                    Términos y condiciones
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/amenazas-ciberseguridad-colombia">
                    Descarga nuestra Guía Gratuita: "Los 5 errores comunes en Seguridad"
                  </ServiceHeadinga>
                </ServiceHeading3>
              </ServiceElement>
            </Col>
            <Col md={3}>
              <ServiceElement>
                <ServiceHeading2>Soluciones</ServiceHeading2>
                <ServiceSeparator />
                <ServiceHeading3>
                  <ServiceHeadinga to="/diseno-web">Diseño Web</ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/desarrollo-de-software">
                    Desarrollo Web
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/desarrollo-de-aplicaciones-moviles">
                    Desarrollo de aplicaciones móviles
                  </ServiceHeadinga>
                </ServiceHeading3>

                <ServiceHeading2i>SSL</ServiceHeading2i>
                <ServiceSeparator />
                <ServiceHeading3>
                  <ServiceHeadinga to="/certificados-ssl">
                    Certificados Digitales
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/certificados-digitales-ssl-san-ucc">
                    SSL SAN/UCC
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/ssl-geotrust">
                    SSL GeoTrust
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/rapidssl">SSL RapidSSL</ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/ssl-vasco">SSL VASCO</ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/ssl-thawte">SSL Thawte</ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/ssl-digicert">
                    SSL Digicert
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/ssl-sectigo">
                    SSL Sectigo
                  </ServiceHeadinga>
                </ServiceHeading3>
              </ServiceElement>
            </Col>
            <Col md={3}>
              <ServiceElement>
                <ServiceHeading2>Infraestructura</ServiceHeading2>
                <ServiceSeparator />
                <ServiceHeading3>
                  <ServiceHeadinga to="/hosting-colombia">
                    Hosting Colombia
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/hosting-cpanel">
                    Hosting cPanel
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/cloud-wordpress-hosting">
                    Cloud WordPress Hosting
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/cloud">Cloud</ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/vps">VPS</ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/vps-kvm">VPS KVM</ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/vps-administrado">
                    VPS Admnistrado
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/servidores-dedicados">
                    Servidores Dedicados
                  </ServiceHeadinga>
                </ServiceHeading3>

                <ServiceHeading2i>Ciberseguridad</ServiceHeading2i>
                <ServiceSeparator />
                <ServiceHeading3>
                  <ServiceHeadinga to="/sitelock">
                    Protección anti Malware SiteLock
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/sgsi-iso27001-colombia">
                    Sistema de Gestión de Seguridad de la Información - SGSI - ISO27001
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/servicios-ciberseguridad-colombia">
                    Ciberseguridad en Colombia
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/seguridad-informatica-colombia">
                    Seguridad Informática en Colombia
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/gobierno-digital-colombia">
                    Política de Gobierno Digital (MSPI,
                    MGRSD, PETI, MIPG)
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/amenazas-ciberseguridad-colombia">
                    Asesoría GRATUITA en Seguridad Informática
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga to="/certimail">Certimail</ServiceHeadinga>
                </ServiceHeading3>
              </ServiceElement>
            </Col>
            <Col md={3}>
              <ServiceElement>
                <ServiceHeading2>WE MAKE IT POSSIBLE</ServiceHeading2>
                <ServiceSeparator />
                <ServiceImg>
                  <ServiceHeadinga href="https://solucionesenlaweb.com">
                    <GatsbyImage
                      image={this.props.image6}
                      alt="VASCO Solutions"
                    />
                  </ServiceHeadinga>
                </ServiceImg>
                <ServiceHeading3v>
                  Reconocimiento MARCA PAÍS TI
                </ServiceHeading3v>
                <ServiceImg>
                  <GatsbyImage
                    image={this.props.image4}
                    alt="Reconocimiento MARCA PAÍS TI"
                  />
                </ServiceImg>
                <ServiceText>
                  <strong>Horario de ventas</strong>
                </ServiceText>
                <ServiceText>
                  Lunes a viernes 8:00 AM a 12 M y 2:00 PM a 6:00 PM
                </ServiceText>
                <ServiceLinea />
                <ServiceHeading3>
                  Conecta:{" "}
                  <ServiceHeadinga to="/conecta">
                    Centro de ayuda
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga href="https://vascosolutions.com/zc/">
                    Zona de Clientes
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  Email:{" "}
                  <ServiceHeadinga href={`mailto:${generateEmailAddress()}`}>
                    {generateEmailAddress()}
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  Teléfono:{" "}
                  <ServiceHeadinga href="tel:+573102767675" rel="nofollow">
                    Colombia +57 310 276 76 75
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  <ServiceHeadinga href="tel:+19546034747" rel="nofollow">
                    USA +1 (786) 723 5100
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  Teams:{" "}
                  <ServiceHeadinga
                    href="https://teams.microsoft.com/l/chat/0/0?users=vasco_solutions"
                    rel="nofollow"
                    target="_blank"
                  >
                    vasco_solutions
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceHeading3>
                  WhatsApp:
                  <ServiceHeadinga
                    href="https://api.whatsapp.com/send?phone=573102767675"
                    rel="nofollow"
                    target="_blank"
                    onClick={() => {
                      console.log("Clic en WhatsApp Texto, enviando evento")
                      if (window.gtag) {
                        window.gtag("event", "click_whatsapp_text", {
                          button_name: "WhatsApp Texto",
                          destination_url:
                            "https://api.whatsapp.com/send?phone=573102767675",
                        })
                      }
                    }}
                  >
                    +57 310 276 7675
                  </ServiceHeadinga>
                </ServiceHeading3>
                <ServiceImg>
                  <a href="/pdf/Propuesta-Valor-VASCO-Solutions.pdf">
                    <GatsbyImage
                      image={this.props.image5}
                      alt="Descargar el perfil de VASCO Solutions en PDF"
                    />
                  </a>
                </ServiceImg>
              </ServiceElement>
            </Col>
          </ServiceRow>
          <ServiceRowF>
            <Col md={3}>
              <ServiceElement>
                <ServiceHeadinga
                  href="https://clutch.co/profile/vasco-solutions"
                  rel="nofollow"
                  target="_blank"
                >
                  <GatsbyImage
                    image={this.props.image2}
                    alt="Clutch VASCO Solutions"
                  />
                </ServiceHeadinga>
              </ServiceElement>
            </Col>
            <Col md={3}>
              <ServiceElement>
                <ServiceHeadinga
                  href="https://vascosolutions.com/zc/"
                  rel="nofollow"
                >
                  <GatsbyImage
                    image={this.props.image3}
                    alt="GoodFirms VASCO Solutions"
                  />
                </ServiceHeadinga>
              </ServiceElement>
            </Col>
            <Col md={3}>
              <ServiceElement>
                <ServiceHeadinga
                  href="https://vascosolutions.com/zc/"
                  rel="nofollow"
                >
                  <GatsbyImage
                    image={this.props.image1}
                    alt="ITFirms VASCO Solutions"
                  />
                </ServiceHeadinga>
              </ServiceElement>
            </Col>
            <Col md={3}>
              <ServiceElement>
                <ServiceHeadinga
                  href="https://vascosolutions.com/zc/"
                  rel="nofollow"
                >
                  <GatsbyImage
                    image={this.props.image}
                    alt="EXTRACT VASCO Solutions"
                  />
                </ServiceHeadinga>
              </ServiceElement>
            </Col>
          </ServiceRowF>
          <Text>
            Copyright © 2025 VASCO Solutions S.A.S. All Rights Reserved.
          </Text>
        </Container>
      </Section>
    )
  }
}

const Iconos = (props) => (
  <StaticQuery
    query={graphql`
      {
        background: file(relativePath: { eq: "vasco-solutions-logo.png" }) {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, width: 500)
          }
        }
        image: file(relativePath: { eq: "icons/extract.png" }) {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, width: 100)
          }
        }
        image1: file(relativePath: { eq: "icons/itfirms.png" }) {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, width: 100)
          }
        }
        image2: file(relativePath: { eq: "icons/clutch.png" }) {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, width: 100)
          }
        }
        image3: file(relativePath: { eq: "icons/goodfirms.png" }) {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, width: 150)
          }
        }
        image4: file(relativePath: { eq: "icons/marca-pais-ti.png" }) {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, width: 100)
          }
        }
        image5: file(relativePath: { eq: "icons/vasco.png" }) {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, width: 254, quality: 100)
          }
        }
        image6: file(relativePath: { eq: "vasco-solutions.png" }) {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, width: 238, quality: 100)
          }
        }
      }
    `}
    render={(data) => {
      const image = getImage(data.image.childImageSharp.gatsbyImageData)
      const image1 = getImage(data.image1.childImageSharp.gatsbyImageData)
      const image2 = getImage(data.image2.childImageSharp.gatsbyImageData)
      const image3 = getImage(data.image3.childImageSharp.gatsbyImageData)
      const image4 = getImage(data.image4.childImageSharp.gatsbyImageData)
      const image5 = getImage(data.image5.childImageSharp.gatsbyImageData)
      const image6 = getImage(data.image6.childImageSharp.gatsbyImageData)
      return (
        <Vasco
          data={data}
          image={image}
          image1={image1}
          image2={image2}
          image3={image3}
          image4={image4}
          image5={image5}
          image6={image6}
          {...props}
        />
      )
    }}
  />
)

export default Iconos
